import { apiClient } from './authenticatedApiClient';
import { AppSingletonPromise } from './AppSingletonPromise';
import { IRegistreerRequest } from '@/model/IRegistreerRequest';
import moment from 'moment';
import Vue from 'vue';
import { AxiosRequestConfig } from 'axios';
class AppRegistrerenService {
  @AppSingletonPromise
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  public registreer(data: IRegistreerRequest): Promise<boolean> {
    // convert Date to UTC timezone
    const d = Object.assign({}, data, {
      geboortedatum: moment(data.geboortedatum).format('YYYY-MM-DD[T00:00:00.000Z]')
    });
    return apiClient
      .post<void>('gebruikers/registreer', d, { _allowedHttpErrors: [404] } as AxiosRequestConfig)
      .then(() => {
        return true;
      })
      .catch(err => {
        Vue.$log.debug('registratie error', err);
        if (err.response.status === 404) {
          return false;
        }
        throw err;
      });
  }
}

export const appRegistrerenService = new AppRegistrerenService();
